import React from 'react'
import styled from 'styled-components'
import { RowFlexDiv } from './CommonStyle'

const ArrowThin = ({ rotate, onClickHandler }) => {
  return (
    <NavbarArrow
      onClick={onClickHandler}
      rotate={rotate}
      src='/images/navbar/minimize-bar.svg'
      alt='arrow-ios-back-outline'
    />
  )
}

export default ArrowThin

const NavbarArrow = styled.img`
  cursor: pointer;
  transition: rotate 0.5s;
  transform: ${({ rotate }) => (rotate ? '' : 'rotateY(180deg)')};
`
